const SET_BUNDLE = (state, payload) => {
    state.bundle = payload
}
/*const setProduct_id = (state, payload) => {
    state.product_id = payload
}*/
const SET_BUNDLE_ID = (state, payload) => {
    state.bundle_id = payload
}
const SET_SELECTED_BUNDLE_ITEMS = (state, payload) => {
    state.selectedBundleItems = payload
}
const SET_SELECTED_BUNDLE_ITEMS_SUMM = (state, payload) => {
    state.selectedBundleItemsSumm = payload
}

export default {
    SET_BUNDLE,
    //setProduct_id,
    SET_BUNDLE_ID,
    SET_SELECTED_BUNDLE_ITEMS,
    SET_SELECTED_BUNDLE_ITEMS_SUMM
}
